import {IonButton, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonImg, IonLabel, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRouterLink, IonRow, IonText, IonTitle, IonToolbar, RefresherEventDetail, useIonRouter} from '@ionic/react';
import {capitalize, productInfo} from '../utils';

import styles from "./Categories.module.scss";
import {useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import {Fragment, useEffect, useRef, useState} from "react";
import {tab1SideMenu} from "../components/sideMenu/PageSideMenus";
import {PageHeader} from "./PageHeader";
import {TokenItem} from "../components/TokenItem";
import {Modal} from "./Modal";
import CustomPage from "./CustomPage";
import {useStoreState} from "pullstate";
import {getPageData} from "../store/Selectors";
import {fetch_pg_7_2_1, fetch_pg_7_3_1, Pg_7_2_1_Store, Pg_7_3_1_Store} from "../store/Pg_7_Store";
import queryString from "query-string";
import {ContractBonusItem} from "../components/ContractBonusItem";
import {TokenEnwItem} from "../components/TokenEnwItem";
import {useParams} from "react-router";
import {chevronDownCircleOutline} from "ionicons/icons";
import {ContractBonusDetailItem} from "../components/ContractBonusDetailItem";
import {fetch_pg_0_3} from "../store/Pg_0_Store";
import {handleCommonFetchErrors, promptBrowserToLogin} from "./Utils";
import {AuthStore} from "../store/Common_Store";
import {CardDetailFor_7_2_1} from "../components/CardDetailFor_7_2_1";
import {CardDetailFor_7_3_1} from "../components/CardDetailFor_7_3_1";

const Pg_7_3_1 = (props) => {
    const pageRef = useRef();
    const pageName = "Pg_7_3_1";
    const pageId = "Pg_7_3_1";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    const router = useIonRouter();

    ///#region 會員
    const authStore = useStoreState(AuthStore, getPageData);
    const hasAuthed = authStore?.signBy ?? false;
    const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;
    ///#endregion

    useEffect(() => {
        setSideMenu({options: sideMenuOptions, side: "start", pageName: pageId});
    }, []);

    //#region Data Loading
    const {contractBonusId}: any = useParams();

    useEffect(() => {
        (async () => {
            let errorObj = await fetch_pg_7_3_1({
                p1: contractBonusId,
            });
            handleCommonFetchErrors(router, errorObj);
        })();
    }, [contractBonusId]);

    let reload = async (event: CustomEvent<RefresherEventDetail>) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        let errorObj = await fetch_pg_7_3_1({
            p1: contractBonusId,
        });
        handleCommonFetchErrors(router, errorObj);
        event?.detail?.complete();
    }

    const pgData = useStoreState(Pg_7_3_1_Store, getPageData);
    const [amountLoaded, setAmountLoaded] = useState(20);
    const [selectedProduct, setSelectedProduct] = useState(false);

    const hasLoaded = pgData?.Root ?? false;
    const Item_Sdgs活動 = hasLoaded ? pgData.Root.Item_Sdgs活動 : undefined;
    const JoinEventState = hasLoaded ? pgData.Root.JoinEventState : undefined;
    const QrCode = hasLoaded ? pgData.Root.QrCode : undefined;

    //#endregion

    return (
        <IonPage id={pageId}>
            <CustomPage name={pageId} sideMenu={false} sideMenuPosition="start" backButton={true} backButtonPath={"/tabs/7_3"}>
                <IonRefresher slot="fixed" onIonRefresh={reload}>
                    <IonRefresherContent
                        pullingIcon={chevronDownCircleOutline}
                        pullingText="Pull to refresh"
                        refreshingSpinner="circles"
                        refreshingText="Refreshing...">
                    </IonRefresherContent>
                </IonRefresher>

                {hasLoaded &&
                    <>
                        <IonGrid className="ion-padding">
                            {/*<IonRow className={ styles.searchContainer }>*/}
                            {/*    <IonCol size="12">*/}
                            {/*        <IonSearchbar animated placeholder="Search for a product" />*/}
                            {/*    </IonCol>*/}
                            {/*</IonRow>*/}


                            {/*click={() => handleShowModal(item)}*/}
                            <IonRow>
                                <CardDetailFor_7_3_1 Item_Sdgs活動={Item_Sdgs活動} reload={reload} JoinEventState={JoinEventState} QrCode={QrCode} noLink={true} onClickCapture={(ev)=> {
                                    if (!hasAuthed) {
                                        promptBrowserToLogin();
                                        ev.stopPropagation();
                                        return false;
                                    }
                                    return true;
                                }}
                                />

                                {/*{List_合約獎勵.map((item, index) => {*/}
                                {/*    return <Fragment key={item.合約獎勵Id}>*/}
                                {/*        */}
                                {/*    </Fragment>*/}
                                {/*})}*/}
                            </IonRow>
                        </IonGrid>
                    </>}
            </CustomPage>
        </IonPage>
    );
};

export default Pg_7_3_1;
